import { render, staticRenderFns } from "./frisoTemp.vue?vue&type=template&id=3d0cc809&scoped=true&"
import script from "./frisoTemp.vue?vue&type=script&lang=js&"
export * from "./frisoTemp.vue?vue&type=script&lang=js&"
import style0 from "./frisoTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./frisoTemp.vue?vue&type=style&index=1&id=3d0cc809&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cc809",
  null
  
)

component.options.__file = "frisoTemp.vue"
export default component.exports